






















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import store from 'src/assets/store'
import Chat from 'src/assets/Chat'
import ChatLayout from 'src/components/chat/Layout.vue'
import { Session, SessionAttendee } from 'src/graphql/types'

@Component({
  components: {
    ChatLayout
  }
})
export default class SessionManagerSessionChat extends Vue {
  chat = new Chat()

  @Prop()
  readonly session!: Session

  get chatInstance () {
    return {
      history: this.chat.history,
      load: (done: (stop?: boolean) => void) => {
        this.chat.load(done)
      },
      send: async (message: string) => {
        if (this.session.data.chatOn) {
          await this.chat.send(message)
        }
      }
    }
  }

  created () {
    this.chat.setSender({
      personId: store.state.person.id,
      name: store.state.person.name,
      avatarUrl: store.state.person.avatarUrl
    })
    this.chat.setSessionId(this.session.id || 0)
  }

  @Watch('session.chatMessages')
  incoming (message: Json) {
    this.chat.messageAppend(this.chat.history, message)
  }
}
